import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

interface FeedbackMessageUpdateRequestData {
	feedbackMessageId: string;
	publish: boolean;
	text: string;
}

export const useUpdateMessage = (options = {}) => {
	const http = useHttpClient('v2');
	const feedbackMessageMutation = useMutation(
		(data: FeedbackMessageUpdateRequestData) => {
			const params = {
				id: data.feedbackMessageId,
				publish: data.publish,
				text: data.text,
			};

			return http.put(`/constructive_feedback/feedback_messages/${data.feedbackMessageId}`, params);
		},
		{
			retry: false,
			...options,
		}
	);

	return feedbackMessageMutation;
};
